import { formatRoundedNumber } from '@/lib/formatUtils';
import { FormFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormFieldState } from '../../hooks';

interface BottomBarProps {
  totalPSNo?: number;
  totalPSCo?: number;
  state: FormFieldState;
}

export function BottomBar({ totalPSNo = 0, totalPSCo = 0, state }: BottomBarProps) {
  const ty_gia = state.ty_gia;
  const isVND = ty_gia == 1;

  return (
    <div className='w-full border-t bg-white px-4 py-2'>
      <div className=''>
        <div className='ml-4 flex flex-col'>
          <div className='flex items-center gap-4'>
            <Label className='w-24 font-bold'>Tổng ps nợ</Label>
            <FormFieldV2 name='t_ps_no_nt' type='text' value={formatRoundedNumber(totalPSNo)} className='min-w-36' />
            <FormFieldV2
              name='t_ps_no'
              className={isVND ? 'hidden' : 'min-w-36 font-semibold'}
              type='text'
              value={formatRoundedNumber(totalPSNo * ty_gia)}
            />
          </div>
        </div>

        <div className='ml-4 flex flex-col'>
          <div className='flex items-center gap-4'>
            <Label className='w-24 font-bold'>Tổng ps có</Label>
            <FormFieldV2 name='t_ps_co_nt' type='text' value={formatRoundedNumber(totalPSCo)} className='min-w-36' />
            <FormFieldV2
              name='t_ps_co'
              className={isVND ? 'hidden' : 'min-w-36 font-semibold'}
              type='text'
              value={formatRoundedNumber(totalPSCo * ty_gia)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
